import { gql } from 'apollo-angular';

export var delete_committee_link = gql`
  mutation deleteCommitteeLink($id: ID!) {
    deleteCommitteeLink(id: $id) {
      id
      name
      url
      is_default_link
    }
  }
`;
